import { Shield } from 'lucide-react';

/**
 * Legal confidentiality banner shown on protected pages.
 */
export function ConfidentialBanner() {
  return (
    <div
      data-testid="confidential-banner"
      className="flex items-center gap-3 px-4 py-2.5 rounded-lg bg-amber-500/5 border border-amber-500/15 mb-4"
    >
      <Shield className="w-4 h-4 text-amber-400 flex-shrink-0" />
      <p className="text-xs text-amber-300/80 leading-relaxed">
        <span className="font-semibold text-amber-300">Contenido confidencial.</span>{' '}
        Esta informacion esta protegida. Su distribucion, copia o captura no autorizada esta prohibida
        y puede resultar en suspension de cuenta y acciones legales conforme a la LFPDPPP.
      </p>
    </div>
  );
}
